import styled from 'styled-components'
import CarsBox from '../../boxes/CarsBox'
import { SIZES } from '../../../constants'

export default styled(CarsBox)`
  flex: 1 1 0%;
  width: 100%;

  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    flex: 1 1 128px;
    max-width: 128px;
  }

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    flex: 1 1 auto;
    border-bottom: 1px solid #d6d6d6;
    padding: 10px 0;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
    }

    & .title-column {
      font-size: 15px;
    }

    & .image-column {
      height: 62px;
      width: 82px;
      position: relative;
    }
  
    & .image-column img {
      height: 62px;
      width: 82px;
    }
  }
`
